import { useState, useEffect, useCallback } from "react";

const SLIDES = [
  { src: "/assets/slide-it.jpg", label: "Information Technology" },
  { src: "/assets/slide-marketing.jpg", label: "Marketing" },
  { src: "/assets/slide-environmental.jpg", label: "Environmental" },
  { src: "/assets/hero-banner.webp", label: "Agriculture" },
];

export const HomeSlider = () => {
  const [index, setIndex] = useState(0);
  const next = useCallback(() => setIndex((i) => (i + 1) % SLIDES.length), []);

  useEffect(() => {
    const t = setInterval(next, 5000);
    return () => clearInterval(t);
  }, [next]);

  return (
    <div data-testid="home-slider" className="mt-12">
      <div className="relative overflow-hidden rounded-2xl shadow-2xl h-72 sm:h-80 lg:h-[28rem] bg-brand-dark">
        {/* Right-to-left sliding track */}
        <div
          className="flex h-full transition-transform duration-700 ease-in-out"
          style={{ transform: `translateX(-${index * (100 / SLIDES.length)}%)`, width: `${SLIDES.length * 100}%` }}>
          {SLIDES.map((s, i) => (
            <div key={i} className="relative h-full" style={{ width: `${100 / SLIDES.length}%` }}>
              <img src={s.src} alt={s.label} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/70 to-transparent" />
              <span className="absolute bottom-4 left-5 text-white font-heading text-lg">{s.label}</span>
            </div>
          ))}
        </div>
      </div>
      {/* Dots */}
      <div className="flex justify-center gap-2 mt-4">
        {SLIDES.map((_, i) => (
          <button
            key={i}
            data-testid={`slider-dot-${i}`}
            onClick={() => setIndex(i)}
            aria-label={`Go to slide ${i + 1}`}
            className={`h-2 rounded-full transition-all duration-300 ${i === index ? "w-6 bg-brand-yellow" : "w-2 bg-white/30 hover:bg-white/50"}`}
          />
        ))}
      </div>
    </div>
  );
};
